import {EventBus} from "./EventBus";

window._ = require('lodash');
window.Vue = require('vue').default;

require('vue-resource');
require('babel-polyfill');
require('./bootstrap');

require('./custom-components');
require('./mountVueComponents');

window.EaseEventBus = new EventBus();
window.EaseEventBus.mountAsVueComponent('app');

window.addEventListener('resize', (event) => {
    EaseEventBus.fire('windowResize', event);
});
